import * as React from "react"
import { Link } from "@gatsbyjs/reach-router"
import { ManualIntegrations } from "./manual-integrations"
import { QuickIntegrations } from "./quick-integrations"
import { CmsProvider } from "@gatsbyjs/graphql"
import { InfoLink } from "../shared/info-link"
import * as styles from "./styles.css"

export type DataSourcesProps = {
  siteId: string
  quickConnectControls: {
    setCmsToEdit: React.Dispatch<React.SetStateAction<CmsProvider | null>>
    setCmsToRemove: React.Dispatch<React.SetStateAction<CmsProvider | null>>
    controlModals: JSX.Element
  }
  permissionToEdit: boolean
}

export function DataSourcesSection({
  siteId,
  quickConnectControls,
  permissionToEdit,
}: DataSourcesProps): JSX.Element {
  const { setCmsToEdit, setCmsToRemove, controlModals } = quickConnectControls

  return (
    <div className={styles.card} id="data-sources">
      <h3 className={styles.cardHeading}>Data sources</h3>

      <h4 className={styles.cardSubHeading}>
        Quick Connect{" "}
        <InfoLink url="/docs" title="Learn about Quick Connect integrations" />
      </h4>
      <p>
        Quick Connect handles automatically connecting and configuring your
        content management system (CMS) integration.
      </p>

      <QuickIntegrations
        siteId={siteId}
        onEdit={setCmsToEdit}
        onRemove={setCmsToRemove}
        controls={controlModals}
        permissionToEdit={permissionToEdit}
      />

      <h4 className={styles.cardSubHeading}>
        Manual setup{" "}
        <InfoLink url="/docs" title="Learn about Manual setup integrations" />
      </h4>
      <p>
        Gatsby Cloud officially supports the following CMS data sources and
        their corresponding Gatsby source plugins:
      </p>

      <ManualIntegrations />

      <p className={styles.integrationListNote}>
        Didn’t find your CMS?{" "}
        <Link to="/plugins">Browse the official Gatsby Plugin directory</Link>{" "}
        for a wide range of data source integrations.
      </p>
    </div>
  )
}
